// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__16oU5","load-effect":"loading_load-effect__38Nog"};